import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useSnackbar } from "components/GlobalSnackbar";
import { apiGetAllCategories } from "api/categories";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles, dialogContentStyles } from "utils/dialogStyles";

function TambahKategoriKutipan({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    kategori_kutipan: "",
    kod_kategori: "",
    bahagian_pemantau: "",
  });
  const { showError } = useSnackbar();

  // Autofill bahagian_pemantau from logged-in user
  useEffect(() => {
    if (open) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setForm((f) => ({ ...f, bahagian_pemantau: user.bahagian || "" }));
    }
  }, [open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      setForm({
        kategori_kutipan: "",
        kod_kategori: "",
        bahagian_pemantau: "",
      });
    }
  }, [open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    // Validate required fields
    if (!form.kategori_kutipan || form.kategori_kutipan.trim() === "") {
      alert("Sila masukkan kategori kutipan yang diperlukan.");
      return;
    }
    if (!form.kod_kategori || form.kod_kategori.trim() === "") {
      alert("Sila masukkan kod kategori yang diperlukan.");
      return;
    }
    if (!form.bahagian_pemantau || form.bahagian_pemantau.trim() === "") {
      alert("Bahagian Pemantau diperlukan.");
      return;
    }
    try {
      // Check for duplicate kod_kategori
      const response = await apiGetAllCategories(1, 1000); // Get all categories to check duplicates
      if (response.data) {
        const existingCategory = response.data.find(
          (category) =>
            category.kod_kategori &&
            category.kod_kategori.toLowerCase() === form.kod_kategori.trim().toLowerCase()
        );
        if (existingCategory) {
          alert("Kod kategori ini sudah wujud dalam sistem. Sila gunakan kod kategori yang lain.");
          return;
        }
      }
      // If no duplicates found, proceed with save
      if (onSave) onSave(form);
      onClose();
    } catch (error) {
      showError("Gagal menyemak kategori. Sila cuba lagi.");
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={dialogHeaderStyles.info}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: "#fff" }}>Tambah Kategori Kutipan</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={dialogContentStyles.light}>
        {/* Maklumat Nama */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Kategori Kutipan"
              name="kategori_kutipan"
              value={form.kategori_kutipan}
              onChange={handleChange}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Kod Kategori"
              name="kod_kategori"
              value={form.kod_kategori}
              onChange={handleChange}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Bahagian Pemantau"
              name="bahagian_pemantau"
              value={form.bahagian_pemantau}
              InputProps={{ readOnly: true }}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogContentStyles.light}>
        <Button
          variant="contained"
          onClick={handleSave}
          size="small"
          sx={{
            ...buttonStyles.save,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          SIMPAN
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          size="small"
          sx={{
            ...buttonStyles.cancel,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          BATAL
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TambahKategoriKutipan.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default TambahKategoriKutipan;
